<template>
  <page-layout :title="title">
    <template v-slot:breadcrumb>
      <li><router-link :to="{ name: 'home' }">Dashboard</router-link></li>
      <li>
        <router-link :to="{ name: 'neyosTracker.list' }"> Balises NEYOS </router-link>
      </li>
      <li class="is-active">
        <a href="#">{{ title }}</a>
      </li>
    </template>
    <o-tabs v-if="neyosTracker" :items="tabItems">
      <template #[TABS.GENERAL.name]>
        <neyos-tracker-information :neyos-tracker.sync="neyosTracker" />
      </template>
      <template #[TABS.STATISTICS.name]>
        <neyos-tracker-statistics :neyos-tracker="neyosTracker" />
      </template>
    </o-tabs>
  </page-layout>
</template>

<script>
import OTabs from '@components/Tabs.vue'
import PageLayout from '@components/PageLayout.vue'
import NeyosTrackerInformation from './NeyosTrackerInformation'
import NeyosTrackerStatistics from './NeyosTrackerStatistics'
import { mapActions } from 'vuex'

export default {
  name: 'EditNeyosTrackerPage',

  components: {
    OTabs,
    PageLayout,
    NeyosTrackerInformation,
    NeyosTrackerStatistics,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      neyosTracker: null,
    }
  },

  created() {
    this.TABS = {
      GENERAL: { label: 'Général', name: 'general' },
      STATISTICS: { label: 'Statistiques', name: 'statistics' },
    }
    this.tabItems = Object.values(this.TABS)
  },

  watch: {
    id: {
      handler: 'load',
      immediate: true,
    },
  },

  computed: {
    title() {
      return this.neyosTracker ? `NEYOS ${this.neyosTracker.number}` : '...'
    },
  },

  methods: {
    ...mapActions('ui', ['addToastMessage']),

    async load() {
      this.loading = true

      try {
        this.neyosTracker = await this.$services.neyosTrackerService.getById(this.id)
      } catch (err) {
        this.neyosTracker = null
        this.addToastMessage({
          text: 'Cette balise NEYOS est introuvable.',
          type: 'is-danger',
        })
        console.error(err)
        this.$router.push({ name: 'neyosTracker.list' })
      }

      this.loading = false
    },
  },
}
</script>
